<template>
    <div class="delivery-management">
        <div class="row">
            <div class="col-12">
                <h3 class="mb-4">{{ $t('cdb.subscriptions.handover') }}</h3>
            </div>
            <div class="col-12 col-xl-6 mb-3 px-0">
                <data-entry-column :title="$t('cdb.subscriptions.kind_of_handover')" :value="$t('cdb.subscriptions.delivery.' + deliveryData.delivery.deliveryMethod)" :full-width="true"></data-entry-column>
            </div>
            <div class="col-12 col-xl-6 mb-3 px-0">
                <data-entry-column :title="$t('cdb.subscriptions.handover_costs')" :value="getDeliveryCosts" :full-width="true"></data-entry-column>
            </div>
            <div class="col-12 col-xl-6 mb-3 px-0">
                <!--                TODO: what exactly is the worflow here?-->
                <data-entry-column :title="$t('cdb.subscriptions.handover_date')" :value="getDeliveryDate" :full-width="true">
                    <!--                    <template v-slot:action>-->
                    <!--                        <span class="text-link">Ändern</span>-->
                    <!--                    </template>-->
                </data-entry-column>
            </div>
            <div class="col-12 col-xl-6 mb-3 px-0">
                <data-entry-column :title="$t('cdb.subscriptions.address')" :full-width="true">
                    <template v-if="deliveryData" v-slot:value>
                        <component
                            v-bind:is="getAddressComponent"
                            :address="deliveryAddress"
                        ></component>
                    </template>
                    <!--                    TODO: add functionality-->
                    <!--                    <template v-slot:action>-->
                    <!--                        <span class="text-link" @click="openChangeAddressModal">Ändern</span>-->
                    <!--                    </template>-->
                </data-entry-column>
            </div>

            <div class="col-12 col-xl-6 mb-3 px-0" v-if="this.isActiveSubStatus && !this.sameAddress">
                <data-entry-column :title="$t('pds.delivery_cost.pickup.location')" :value=this.pickupDisplayLocation :full-width="true"></data-entry-column>
            </div>
            <div class="col-12 col-xl-6 mb-3 px-0" v-if="this.isActiveSubStatus && this.hasPickupLocation && !this.sameAddress">
                <data-entry-column :title="$t('pds.delivery_cost.return.location')" :value=this.returnDisplayLocation :full-width="true"></data-entry-column>
            </div>
            <div class="col-12 col-xl-6 mb-3 px-0" v-if="this.isActiveSubStatus && this.hasPickupLocation && this.sameAddress">
                <data-entry-column :title="$t('pds.delivery_cost.pickup.return.location')" :value=this.pickupDisplayLocation :full-width="true"></data-entry-column>
            </div>

        </div>
    </div>
</template>

<script>
import { EventBus } from '../../event-bus';
import DataEntryColumn from "../atoms/DataEntryColumn.vue";
import moment from 'moment';
import AddressBox from "./AddressBox.vue";

export default {
    name: 'DeliveryManagement',
    components: {
        DataEntryColumn, AddressBox
    },
    props: {
        deliveryData: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            deliveryAddress: this.getAddressObject,
        }
    },
    methods: {
        openChangeAddressModal() {
            EventBus.$emit('init-change-address', {todo: true});
        },
        getDisplayLocation: function (address) {
            return this.$root.whitelabel.isUs() ? `${address.city} ${address.postal_code}` : `${address.postal_code} ${address.city}`
        },
        getAddressObject() {
            if(this.deliveryMethod === 'pickup') {
                this.deliveryAddress.street = this.vehicleAddress.street;
                this.deliveryAddress.house_number = this.vehicleAddress.house_number;
                this.deliveryAddress.postal_code = this.vehicleAddress.postal_code;
                this.deliveryAddress.city = this.vehicleAddress.city;
                this.deliveryAddress.region = this.vehicleAddress.region ? this.vehicleAddress.region : '';
                this.deliveryAddress.country = this.vehicleAddress.country;
            } else {
                const data = this.deliveryData.delivery_address_data
                this.deliveryAddress.street =  data ? data.street : '';
                this.deliveryAddress.house_number = data ? data.house_number : '';
                this.deliveryAddress.postal_code = data ? data.postal_code : '';
                this.deliveryAddress.city = data ? data.city : '';
                this.deliveryAddress.region = data && data.region ? data.region : '';
                this.deliveryAddress.country = data ? data.country : '';
            }
        }
    },
    computed: {
        deliveryMethod() {
            return this.deliveryData.delivery.deliveryMethod
        },
        vehicleAddress() {
            const { address } = this.deliveryData.vehicle
            return address
        },
        getDeliveryDate() {
            let dateString
            if(this.deliveryData.delivery.handover_date) {
                let date = moment(this.deliveryData.delivery.handover_date)
                if(this.$root.$i18n.locale == 'en-US'){
                    dateString = `${date.format("MMMM Do YYYY")} <br> ${date.format("h:mm A")}`
                } else {
                    dateString = `${date.format("DD.MM.YYYY")} <br> ${date.format("h:mm")} ${this.$t('general.oClock')}`
                }
            }

            return this.deliveryData.delivery.handover_date ? dateString : `${this.$t('cdb.subscriptions.no_handover_date')}`
        },
        getDeliveryCosts() {
            let price = 0
            const showWithoutVat = this.$root.whitelabel.setting('show_price_without_taxes')
            const vatText = showWithoutVat ? this.$t('general.net') : ''

            if (this.deliveryData.delivery.deliveryMethod !== 'pickup') {
                price = showWithoutVat ? this.deliveryData.delivery.deliveryCosts_net : this.deliveryData.delivery.deliveryCosts
            }

            return `${this.$root.whitelabel.getFormatetPrice(price)} ${vatText}`
        },
        returnDisplayLocation() {
            return this.deliveryData.vehicle ? this.getDisplayLocation(this.deliveryData.vehicle.first_return_location) : ''
        },
        pickupDisplayLocation() {
            return this.deliveryData.vehicle ? this.getDisplayLocation(this.deliveryData.vehicle.address) : ''
        },
        hasPickupLocation() {
            return this.deliveryData.vehicle ? this.deliveryData.vehicle.hasOwnProperty('first_return_location') : false
        },
        sameAddress() {
            if (!this.deliveryData.vehicle || !this.deliveryData.vehicle.hasOwnProperty('first_return_location')) {
                return false
            } else {
                return this.pickupDisplayLocation === this.returnDisplayLocation
            }
        },
        isActiveSubStatus() {
            return ['SUBSCRIPTION_ACTIVE', 'SUBSCRIPTION_CUSTOMER_CANCELLATION', 'SUBSCRIPTION_PARTNER_CANCELLATION'].includes(this.deliveryData.status)
        },
        getAddressComponent(){
            this.getAddressObject();
            return "address-box";
        }
    }
}
</script>
